/**
 * Client for Space Manage → Members: the moderator directory, kick with a
 * reason, and moderator notes. Kept apart from `SpacesApi` (already large).
 *
 * @module api/space-members-api
 */
function spacePath(spaceId) {
    return `/api/spaces/${encodeURIComponent(spaceId)}`;
}
function memberPath(spaceId, identityId) {
    return `${spacePath(spaceId)}/members/${encodeURIComponent(identityId)}`;
}
function withQuery(path, params) {
    const query = params.toString();
    return query ? `${path}?${query}` : path;
}
export class SpaceMembersApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** One directory page. Requires `manageMembers`. */
    async listDirectory(spaceId, options = {}, requestOptions) {
        const params = new URLSearchParams();
        if (options.status)
            params.set('status', options.status);
        if (options.q)
            params.set('q', options.q);
        if (options.sort)
            params.set('sort', options.sort);
        if (options.roleId)
            params.set('roleId', options.roleId);
        if (options.temporary)
            params.set('temporary', '1');
        if (options.reason)
            params.set('reason', options.reason);
        if (options.limit != null)
            params.set('limit', String(options.limit));
        if (options.cursor)
            params.set('cursor', options.cursor);
        return this.client.get(withQuery(`${spacePath(spaceId)}/manage/members`, params), requestOptions);
    }
    /** Directory row for one identity, whatever their status. */
    async getDirectoryEntry(spaceId, identityId) {
        return this.client.get(`${spacePath(spaceId)}/manage/members/${encodeURIComponent(identityId)}`);
    }
    /** Audit entries about one member, newest first. Requires `viewAuditLog`. */
    async listHistory(spaceId, identityId, options) {
        const params = new URLSearchParams({ targetIdentityId: identityId });
        if (options?.limit != null)
            params.set('limit', String(options.limit));
        if (options?.cursor)
            params.set('cursor', options.cursor);
        return this.client.get(withQuery(`${spacePath(spaceId)}/audit-log`, params));
    }
    /** Remove a member, recording an optional moderator reason. Requires `kickMembers`. */
    async kick(spaceId, identityId, body = {}) {
        return this.client.post(`${memberPath(spaceId, identityId)}/kick`, body);
    }
    async listNotes(spaceId, identityId, options) {
        const params = new URLSearchParams();
        if (options?.limit != null)
            params.set('limit', String(options.limit));
        if (options?.cursor)
            params.set('cursor', options.cursor);
        return this.client.get(withQuery(`${memberPath(spaceId, identityId)}/notes`, params));
    }
    async createNote(spaceId, identityId, body) {
        return this.client.post(`${memberPath(spaceId, identityId)}/notes`, { body });
    }
    async updateNote(spaceId, identityId, noteId, body) {
        return this.client.patch(`${memberPath(spaceId, identityId)}/notes/${encodeURIComponent(noteId)}`, { body });
    }
    async deleteNote(spaceId, identityId, noteId) {
        return this.client.delete(`${memberPath(spaceId, identityId)}/notes/${encodeURIComponent(noteId)}`);
    }
}
//# sourceMappingURL=space-members-api.js.map